import en from "./en.json";
import es from "./es.json";
import template from "./otp_login.html";
import mixpanel from "mixpanel-browser";

class OTPLoginController {
    /* @ngInject */
    constructor(AuthService, $window) {
        this.AuthService = AuthService;
        this.$window = $window;
        this.otpInput = {};
        this.errors = {};
    }

    $onInit() {
        let ctrl = this;
        ctrl.credentials = ctrl.credentials || {};
    }

    $onDestroy() {
        let ctrl = this;
        ctrl.destroyed = true;
    }

    requestCode(credentials) {
        let ctrl = this;
        return ctrl.request("code", credentials);
    }

    requestLink(credentials) {
        let ctrl = this;
        return ctrl.request("link", credentials);
    }

    request(method, credentials) {
        let ctrl = this;
        if (ctrl.busy) {
            return;
        }
        ctrl.errors = {};
        ctrl.requestFailed = false;
        ctrl.busy = true;
        let submittedCredentials = { ...credentials };
        let request =
            method === "code"
                ? ctrl.AuthService.otpRequestCode(submittedCredentials)
                : ctrl.AuthService.requestPasswordlessLogin(
                      submittedCredentials,
                  );
        return request
            .then(
                function (response) {
                    if (ctrl.destroyed) {
                        return;
                    }
                    ctrl.channel = response.data.signin_channel;
                    submittedCredentials.mobile_email =
                        response.data.mobile_email ||
                        submittedCredentials.mobile_email;
                    ctrl.sentCredentials = submittedCredentials;
                    ctrl.otpInput = { ...submittedCredentials, code: "" };
                    ctrl.showCodeInput = method === "code";
                    ctrl.showLinkSent = method === "link";
                    mixpanel.track(
                        method === "code"
                            ? "Requested otp code"
                            : "Requested login link",
                        {
                            channel: ctrl.channel,
                        },
                    );
                },
                function (reason) {
                    if (ctrl.destroyed) {
                        return;
                    }
                    ctrl.errors = reason.data || {};
                    ctrl.requestFailed =
                        !ctrl.errors.mobile_email &&
                        !ctrl.errors.non_field_errors;
                },
            )
            .finally(function () {
                ctrl.busy = false;
            });
    }

    startOver() {
        let ctrl = this;
        if (ctrl.busy) {
            return;
        }
        ctrl.credentials.mobile_email = ctrl.sentCredentials.mobile_email;
        ctrl.showCodeInput = false;
        ctrl.showLinkSent = false;
        ctrl.errors = {};
        ctrl.requestFailed = false;
        ctrl.otpInput = {};
    }

    switchMethod() {
        let ctrl = this;
        return ctrl.request(
            ctrl.showLinkSent ? "code" : "link",
            ctrl.sentCredentials,
        );
    }

    verifyCode(data) {
        let ctrl = this;
        if (ctrl.busy) {
            return;
        }
        ctrl.busy = true;
        ctrl.errors = {};
        ctrl.requestFailed = false;
        return ctrl.AuthService.otpVerifyCode(data).then(
            function (response) {
                if (ctrl.destroyed) {
                    return;
                }
                mixpanel.track("Verified login code", {
                    channel: ctrl.channel,
                });
                ctrl.$window.location = response.data.redirect_url;
            },
            function (reason) {
                if (ctrl.destroyed) {
                    return;
                }
                ctrl.errors = reason.data || {};
                ctrl.requestFailed =
                    !ctrl.errors.code &&
                    !ctrl.errors.mobile_email &&
                    !ctrl.errors.non_field_errors;
                ctrl.busy = false;
            },
        );
    }
}

export default {
    controller: OTPLoginController,
    template: template,
    bindings: { credentials: "<" },
    name: "otpLogin",
    translations: { en, es },
};
